"use strict";

var _classCallCheck = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var http2 = require("http2");

var _http2$constants = http2.constants,
    HTTP2_HEADER_AUTHORITY = _http2$constants.HTTP2_HEADER_AUTHORITY,
    HTTP2_HEADER_CONTENT_TYPE = _http2$constants.HTTP2_HEADER_CONTENT_TYPE,
    HTTP2_HEADER_METHOD = _http2$constants.HTTP2_HEADER_METHOD,
    HTTP2_HEADER_PATH = _http2$constants.HTTP2_HEADER_PATH,
    HTTP2_HEADER_TE = _http2$constants.HTTP2_HEADER_TE,
    HTTP2_HEADER_USER_AGENT = _http2$constants.HTTP2_HEADER_USER_AGENT;
/* setInterval and setTimeout only accept signed 32 bit integers. JS doesn't
 * have a constant for the max signed 32 bit integer, so this is a simple way
 * to calculate it */

var KEEPALIVE_TIME_MS = ~(1 << 31);
var KEEPALIVE_TIMEOUT_MS = 20000;

var Http2SubChannel =
/*#__PURE__*/
function (_events_1$EventEmitte) {
  _inherits(Http2SubChannel, _events_1$EventEmitte);

  function Http2SubChannel(target, connectionOptions, userAgent, channelArgs) {
    var _this;

    _classCallCheck(this, Http2SubChannel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Http2SubChannel).call(this));
    _this.refCount = 0;
    _this.keepaliveTimeMs = KEEPALIVE_TIME_MS;
    _this.keepaliveTimeoutMs = KEEPALIVE_TIMEOUT_MS;
    _this.session = http2.connect(target, connectionOptions);

    _this.session.on('connect', function () {
      _this.emit('connect');
    });

    _this.session.on('close', function () {
      _this.stopKeepalivePings();

      _this.emit('close');
    });

    _this.session.on('error', function () {
      _this.stopKeepalivePings();

      _this.emit('close');
    });

    _this.userAgent = userAgent;

    if (channelArgs['grpc.keepalive_time_ms']) {
      _this.keepaliveTimeMs = channelArgs['grpc.keepalive_time_ms'];
    }

    if (channelArgs['grpc.keepalive_timeout_ms']) {
      _this.keepaliveTimeoutMs = channelArgs['grpc.keepalive_timeout_ms'];
    }

    _this.keepaliveIntervalId = setTimeout(function () {}, 0);
    clearTimeout(_this.keepaliveIntervalId);
    _this.keepaliveTimeoutId = setTimeout(function () {}, 0);
    clearTimeout(_this.keepaliveTimeoutId);
    return _this;
  }

  _createClass(Http2SubChannel, [{
    key: "ref",
    value: function ref() {
      if (this.refCount === 0) {
        this.session.ref();
        this.startKeepalivePings();
      }

      this.refCount += 1;
    }
  }, {
    key: "unref",
    value: function unref() {
      this.refCount -= 1;

      if (this.refCount === 0) {
        this.session.unref();
        this.stopKeepalivePings();
      }
    }
  }, {
    key: "sendPing",
    value: function sendPing() {
      var _this2 = this;

      this.keepaliveTimeoutId = setTimeout(function () {
        _this2.emit('close');
      }, this.keepaliveTimeoutMs);
      this.session.ping(function (err, duration, payload) {
        clearTimeout(_this2.keepaliveTimeoutId);
      });
    }
    /* TODO(murgatroid99): refactor subchannels so that keepalives can be handled
     * per subchannel */

  }, {
    key: "startKeepalivePings",
    value: function startKeepalivePings() {
      var _this3 = this;

      this.keepaliveIntervalId = setInterval(function () {
        _this3.sendPing();
      }, this.keepaliveTimeMs);
      this.sendPing();
    }
  }, {
    key: "stopKeepalivePings",
    value: function stopKeepalivePings() {
      clearInterval(this.keepaliveIntervalId);
      clearTimeout(this.keepaliveTimeoutId);
    } // Prerequisite: this subchannel is connected

  }, {
    key: "startCallStream",
    value: function startCallStream(metadata, callStream) {
      var _this4 = this;

      var headers = metadata.toHttp2Headers();
      headers[HTTP2_HEADER_AUTHORITY] = callStream.getHost();
      headers[HTTP2_HEADER_USER_AGENT] = this.userAgent;
      headers[HTTP2_HEADER_CONTENT_TYPE] = 'application/grpc';
      headers[HTTP2_HEADER_METHOD] = 'POST';
      headers[HTTP2_HEADER_PATH] = callStream.getMethod();
      headers[HTTP2_HEADER_TE] = 'trailers';
      var http2Stream = this.session.request(headers);
      this.ref();
      http2Stream.on('close', function () {
        _this4.unref();
      });
      callStream.attachHttp2Stream(http2Stream);
    }
  }, {
    key: "close",
    value: function close() {
      this.session.close();
    }
  }]);

  return Http2SubChannel;
}(events_1.EventEmitter);

exports.Http2SubChannel = Http2SubChannel;